// extracted by mini-css-extract-plugin
export default {"container":"agGrid_container__ZbLIu","pivot":"agGrid_pivot__CuG2z"};